/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Sendingotp1Inputs */

const he_auth_login_sendingotp1 = /** @type {(inputs: Auth_Login_Sendingotp1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שולח קוד...`)
};

const en_auth_login_sendingotp1 = /** @type {(inputs: Auth_Login_Sendingotp1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sending code...`)
};

/**
* | output |
* | --- |
* | "Sending code..." |
*
* @param {Auth_Login_Sendingotp1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const auth_login_sendingotp1 = /** @type {((inputs?: Auth_Login_Sendingotp1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Sendingotp1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_auth_login_sendingotp1(inputs)
	return en_auth_login_sendingotp1(inputs)
});
export { auth_login_sendingotp1 as "auth_login_sendingOtp" }